// Single source of truth for public/unauthenticated routes. Extracted from App.jsx
// so the help FAB and the analytics FAB share one definition (Codex P2.4).
export const PUBLIC_ROUTES = ['/', '/home', '/login', '/auth/verify', '/terms', '/privacy', '/v1', '/demo'];
export const PUBLIC_ROUTE_PREFIXES = ['/for/', '/unsubscribe/'];

export function isPublicRoute(pathname) {
  return PUBLIC_ROUTES.includes(pathname) || PUBLIC_ROUTE_PREFIXES.some((p) => pathname.startsWith(p));
}
